import { render, staticRenderFns } from "./loadManagement.vue?vue&type=template&id=ad37401c&scoped=true&"
import script from "./loadManagement.vue?vue&type=script&lang=js&"
export * from "./loadManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad37401c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad37401c')) {
      api.createRecord('ad37401c', component.options)
    } else {
      api.reload('ad37401c', component.options)
    }
    module.hot.accept("./loadManagement.vue?vue&type=template&id=ad37401c&scoped=true&", function () {
      api.rerender('ad37401c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/loadManagement.vue"
export default component.exports